var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQThumbsDownRoundFill = function SvgQThumbsDownRoundFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 68 68"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33.999,
    cy: 33.997,
    r: 28.333,
    fill: "#F1E3FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F1E3FB",
    fillRule: "evenodd",
    stroke: "#A755E8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.187,
    d: "M44.056 37.131v-15l-13.457-1.283a3.48 3.48 0 0 0-3.414 1.84l-5.098 9.558c-1.248 2.342.424 5.188 3.052 5.188h8.074c.616 0 .97.695.622 1.208-1.567 2.3-4.177 7.282.69 9.526l.556-1.008c1.754-3.176 3.38-6.258 8.975-9.927z",
    clipRule: "evenodd"
  })));
};
export { SvgQThumbsDownRoundFill as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjgiIGhlaWdodD0iNjgiIHZpZXdCb3g9IjAgMCA2OCA2OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMzMuOTk5NCIgY3k9IjMzLjk5NzQiIHI9IjI4LjMzMzMiIGZpbGw9IiNGMUUzRkIiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00NC4wNTU3IDM3LjEzMUw0NC4wNTU3IDIyLjEzMTJMMzAuNTk5NCAyMC44NDc4QzI5LjIwMDUgMjAuNzA3MiAyNy44NTMxIDIxLjQzNDMgMjcuMTg1MyAyMi42ODc2TDIyLjA4NyAzMi4yNDYzQzIwLjgzODcgMzQuNTg4MiAyMi41MTEgMzcuNDM0MyAyNS4xMzg1IDM3LjQzNDNMMzMuMjEyOSAzNy40MzQzQzMzLjgyOTIgMzcuNDM0MyAzNC4xODM4IDM4LjEyOTMgMzMuODM1MSAzOC42NDE1QzMyLjI2NzggNDAuOTQxMiAyOS42NTgyIDQ1LjkyNDQgMzQuNTI0NyA0OC4xNjhMMzUuMDgxNCA0Ny4xNTk3QzM2LjgzNSA0My45ODQyIDM4LjQ2MSA0MC45MDIyIDQ0LjA1NTcgMzcuMjMzTDQ0LjA1NTcgMzcuMTMxWiIgZmlsbD0iI0YxRTNGQiIgc3Ryb2tlPSIjQTc1NUU4IiBzdHJva2Utd2lkdGg9IjIuMTg2OTUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K";